import React, { useEffect } from "react";
import Rating from "@mui/material/Rating";
import { useTranslation } from "react-i18next";
import translateLDSDestinations from "../../../../services/translateLDSDestinations";
import NoResults from "../../../../assets/images/icons/no-results.png";

import "./packageobject.scss";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "../../../../Routes/Routes";
import { useSelectedResult } from "../../../../contexts/SelectedResultContext";
import { Loader } from "../../../Loader/Loader";

import { WiTime8 } from "react-icons/wi";
import { MdOutlineDirectionsBus } from "react-icons/md";
import { SlCalender } from "react-icons/sl";
import { useSearch } from "../../../../contexts/SearchContext";
import { Tooltip } from "antd/lib";
import infoSymbol from "../../../../assets/images/icons/info.svg";
import {
  findExtendedDeals,
  getPackageFlightLinks,
} from "../../../../services/fhpService";
import { Button, Skeleton } from "antd";
import FlightSelection from "../../../FlightSelection/Index";
import { motion } from "framer-motion";

const PackageObject = ({ fullDeal, shortenedDeal }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { setSelectedResult_resetAllFields, ilsToUsd, roomsAndPaxInfo } =
    useSelectedResult();
  const {
    calculateLDSDealFareForRoomsComposition,
    selectedDepart,
    setSelectedDepart,
    selectedReturn,
    setSelectedReturn,
    setSavedDeal,
  } = useSearch();
  const [extendedDeal, setExtendedDeal] = React.useState(null);
  const [loadingLinkedFlights, setLoadingLinkedFlights] = React.useState(false);
  const [loadingExtendedDeal, setLoadingExtendedDeal] = React.useState(false);
  const [linkedFlights, setLinkedFlights] = React.useState(
    fullDeal?.linkedFlights || []
  );

  const getBoardDetails = (LDSboard) => {
    switch (LDSboard) {
      case "BB":
        return t("boards.BB");
      case "HB":
        return t("boards.HB");
      case "FB":
        return t("boards.FB");
      case "AI":
        return t("boards.AI");
      case "RO":
        return t("boards.RO");
      default:
        return LDSboard;
    }
  };

  const handleClick = () => {
    if (
      selectedDepart !== null &&
      selectedReturn !== null &&
      Array.isArray(linkedFlights)
    )
      fullDeal.linkedFlights = linkedFlights.find((linkedFlight) => {
        return (
          linkedFlight.flight[0].leg.depDate === selectedDepart.depDate &&
          linkedFlight.flight[1].leg.depDate === selectedReturn.depDate
        );
      });
    setSelectedResult_resetAllFields(fullDeal);
    navigate(`/${ROUTES.PACKAGE_PROFILE}`);
  };

  const update_extended_deal = (ldsDealId) => {
    setLoadingExtendedDeal(true);
    findExtendedDeals({
      lds_deal_id: ldsDealId,
    })
      .then((res) => {
        let extendedDeal = res?.data?.extendedDeal;
        if (extendedDeal && !Array.isArray(extendedDeal)) {
          extendedDeal = [extendedDeal];
        }
        setExtendedDeal(extendedDeal);
        setLoadingExtendedDeal(false);
      })
      .catch((err) => {
        setLoadingExtendedDeal(false);
      });
  };

  useEffect(() => {
    if (!fullDeal) return;
    const { linkedFlights, numOfFlightLinks } = fullDeal;
    const { ldsDealId, flight } = linkedFlights;
    const rooms = roomsAndPaxInfo.length;
    if (rooms > 1) {
      let diff = false;
      let prev = null;
      for (let i = 0; i < rooms; i++) {
        if (prev === null) prev = roomsAndPaxInfo[i];
        else if (
          prev.adults.length !== roomsAndPaxInfo[i].adults.length ||
          prev.kids.length !== roomsAndPaxInfo[i].kids.length ||
          prev.infants.length !== roomsAndPaxInfo[i].infants.length
        ) {
          diff = true;
          break;
        }
      }
      if (diff) update_extended_deal(ldsDealId);
    }

    if (numOfFlightLinks > 1) {
      setLoadingLinkedFlights(true);
      getPackageFlightLinks({ id: ldsDealId, pax: 2 })
        .then((res) => {
          if (res?.data?.linkedFlights)
            setLinkedFlights(res.data.linkedFlights);
          else if (linkedFlights) {
            setLinkedFlights(linkedFlights);
          }
          setLoadingLinkedFlights(false);
        })
        .catch((err) => {
          if (linkedFlights) {
            setLinkedFlights(linkedFlights);
          }
          setLoadingLinkedFlights(false);
        });
    } else if (linkedFlights) {
      setLinkedFlights(linkedFlights);
    }
  }, [fullDeal]);

  const renderHotelData = () => {
    if (!fullDeal) return null;
    const { hotel, isTransferIncluded, supplierDetails, hotelAllocation } =
      fullDeal;

    const supplierId = supplierDetails?.supplierId;

    const ourPrice = calculateLDSDealFareForRoomsComposition(
      fullDeal,
      extendedDeal || shortenedDeal
    );
    // fullDeal.ourPrice = ourPrice;

    const { ourTotalFare, ourAdultFare, ourChildFare, ourInfantFare } =
      ourPrice || {};

    const starRating = hotel?.category?.replace(/\D/g, "");
    const boardDetails = getBoardDetails(hotel?.board);
    const isAutoApprove = hotelAllocation === "true";
    const translatedName = translateLDSDestinations(hotel?.hotelCity);

    const ourChildFareView =
      ourChildFare?.map((childFare, childIndex) => {
        return (
          <>
            <br />
            {t("packages.childPrice") +
              " " +
              (ourChildFare.length > 1
                ? (childIndex + 1).toString() + " "
                : "")}
            {childFare.priceWithCommissionAndCreditCardFee ||
              ourAdultFare.priceWithCommissionAndCreditCardFee}
            ₪
          </>
        );
      }) || [];

    return (
      <div className="hotel-data lg:tw-flex tw-flex-col lg:tw-flex-row ">
        <img
          className="hotel-img"
          src={hotel?.resourceUrl || NoResults}
          alt={hotel?.hotelName}
        />
        <div className="center-hotel-data">
          <div className="hotel-name">
            {hotel?.hotelName}
            <Rating
              name="read-only"
              value={starRating}
              readOnly
              visuallyHidden
              size="small"
              emptyIcon={<></>}
            />
          </div>
          <div className="hotel-city">
            {translatedName.COUNTRYNAME_HEB} - {translatedName.CITYNAME_HEB}
          </div>
          <div className="text-with-icon tw-text-sm lg:tw-text-base">
            <SlCalender className="orange-icon" />
            <div className="text">
              {hotel?.checkInDate} - {hotel?.checkOutDate} | {boardDetails}
            </div>
          </div>

          <div className="text-with-icon tw-text-sm lg:tw-text-base">
            <WiTime8 className="orange-icon" />

            <div className="text">
              {hotel?.nights} {t("packages.nights")}
            </div>
          </div>

          {isTransferIncluded === "true" && (
            <div className="text-with-icon tw-text-sm lg:tw-text-base">
              <MdOutlineDirectionsBus className="orange-icon" />

              <div className="text">כולל העברות</div>
            </div>
          )}

          <div className="text-with-icon tw-text-sm lg:tw-text-base">
            <div className="text">
              {t("packages.supplierId") + ": " + supplierId}
            </div>
          </div>
        </div>
        {loadingExtendedDeal ? (
          <div
            className="skeleton"
            style={{
              width: "100%",
              height: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Skeleton
              active
              style={{
                width: "95%",
              }}
            />
          </div>
        ) : (
          <div
            className="price-data"
            style={{
              marginBottom: "20px",
            }}
          >
            {/* todo(sagiv): Add loader*/}
            <div className="total-price">
              {ourTotalFare?.priceWithCommissionAndCreditCardFee + "₪"}
            </div>
            <div className="total-price-usd">
              {ilsToUsd(ourTotalFare?.priceWithCommissionAndCreditCardFee) +
                "$"}
            </div>
            <div
              className="total-title"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {t("packages.totalFare")}
              <Tooltip
                title={
                  <div className="details">
                    {t("packages.passangerPrice")}{" "}
                    {ourAdultFare?.priceWithCommissionAndCreditCardFee}₪
                    {ourChildFareView}
                    {ourTotalFare?.priceWithCommissionAndCreditCardFee ? (
                      <br />
                    ) : (
                      ""
                    )}
                    {ourInfantFare?.priceWithCommissionAndCreditCardFee
                      ? t("packages.infantPrice") +
                        " " +
                        ourInfantFare?.priceWithCommissionAndCreditCardFee +
                        "₪"
                      : ""}
                  </div>
                }
              >
                <img
                  src={infoSymbol}
                  alt="info"
                  style={{
                    width: "15px",
                    height: "15px",
                    marginRight: "5px",
                  }}
                />
              </Tooltip>
            </div>
            {isAutoApprove ? (
              <div className="auto-approve"> {t("packages.autoApprove")}</div>
            ) : (
              <div className="not-auto-approve">נדרש אישור של המלון</div>
            )}
            <div className="order-btn">
              <motion.div
                whileHover={{
                  scale: 1.05,
                  boxShadow: "0px 4px 20px rgba(250,140,22,0.2)",
                }}
                whileTap={{ scale: 0.97 }}
                style={{ width: "100%" }}
              >
                <Button
                  type="primary"
                  style={{
                    width: "100%",
                    backgroundColor: "#fa8c16",
                    color: "#fff",
                    borderColor: "#fa8c16",
                    transition: "box-shadow 0.2s, transform 0.2s",
                  }}
                  onClick={handleClick}
                >
                  {t("packages.order")}
                </Button>
              </motion.div>
            </div>
          </div>
        )}
        <FlightSelection
          linkedFlightsData={linkedFlights || fullDeal.linkedFlights}
          loadingLinkedFlights={loadingLinkedFlights}
          isCompact={true}
        />
      </div>
    );
  };

  return (
    <div className="package-wrapper hover:tw-bg-slate-200 md:tw-h-full">
      {!fullDeal ? <Loader size="small" /> : <>{renderHotelData()}</>}
    </div>
  );
};

export default PackageObject;
